<template>
  <div class="newdetail">
    <div class="title">{{newDetail.title}}</div>
    <div class="attr">
      <span>{{newDetail.created_time}}</span>
      <span>浏览次数 {{newDetail.look_count}}</span>
    </div>
    <div v-if="newDetail.type === 2">
      <video-player
        class="video-player vjs-custom-skin"
        ref="videoPlayer"
        :options="playerOptions"
        :playsinline="true"
      ></video-player>
    </div>
    <div class="newhtml" v-html="newDetail.content"></div>
  </div>
</template>

<script>

import 'video.js/dist/video-js.css'
import '../../static/video.css'
import { videoPlayer } from 'vue-video-player'
export default {
  data () {
    return {
      newDetail: {},
      playerOptions: {
        height: '390',
        autoplay: 'play',
        muted: false,
        // playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [{
          type: 'video/mp4',
          // mp4
          src: 'http://wxsmjphoto.wanjiejixie.com/guanwang/video.mp4'
          // webm
          // src: "https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm"
        }],
        fluid: true// 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
      },
    }
  },
  metaInfo() {
    return {
      title: this.newDetail.seo_title || this.newDetail.title,
      meta: [
        {
          name: 'keywords',
          content: this.newDetail.seo_keyword || this.newDetail.title
        },
        {
          name: 'description',
          content: this.newDetail.seo_info || this.newDetail.title
        }
      ]
    };
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        console.log(val)
        scrollTo(0, 800)
      },
      // 深度观察监听
      deep: true
    }
  },
  mounted () {
    // console.log(this.$route.params.id)
    this.$https.fetchPost('/Article/article_detail', {
      id: this.$route.params.id
    }).then((res) => {
      // console.log(res.data)
      this.newDetail = res.data.data
      if (res.data.data.type === 2) {
        this.playerOptions['sources'][0]['src'] = res.data.data.video_audio;
      }
    }).catch(err => {
      console.log(err)
    })

    // 增加浏览量
    this.$https.fetchPost('/Article/article_look_count', {
    }).then((res) => { })
  },
  computed: {
    player () {
      return this.$refs.videoPlayer.player
    }
  },
  components: {
    videoPlayer
  }

}
</script>
<style lang='less'>
/*no*/
.newdetail {
  background: #ffffff;
  padding: 0 40px 80px;
  .title {
    font-family: MicrosoftYaHei-Bold;
    font-size: 42px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 60px;
    letter-spacing: 0.4px;
    color: rgba(17, 17, 17, 1);
    padding: 30px 0 20px;
  }
  .attr {
    font-size: 28px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 40px;
    letter-spacing: 0.7px;
    color: rgba(179, 179, 179, 1);
    margin-bottom: 30px;
    span {
      margin-right: 10px;
    }
  }
  .newhtml{
    font-size: 32px;
    line-height: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NewsDetail.vue